import api from './api';
import apiNoHeaders from './apiNoHeaders';
import idbService from './idbService';

// idb store name
const storeName = 'unidades';

// Recurso SQL Api Syclus
const environment = process.env.NODE_ENV;
const configLocal = localStorage.getItem('configColetor');
const host = configLocal ? JSON.parse(configLocal).host : '';
const baseURL = environment === 'production' ? `erp?url=${host}` : host;
const apiRequest = environment === 'production' ? api : apiNoHeaders;
const sqlUnidades = configLocal ? JSON.parse(configLocal).sqlUnidades : '';

export const unidadeService = {
  getUnidades,
  getUnidadesAPI,
};

async function getUnidades() {
  // Fetch indexedDB Items
  const itemsIndexedDB = await getIndexedDBUnidades();
  if (itemsIndexedDB.length) return itemsIndexedDB;
  return getUnidadesAPI();
}


async function getUnidadesAPI() {
  const response = await apiRequest.get(`${baseURL}/sql/${sqlUnidades}`);
  const unidadesApi = environment === 'production' ? response.data.result.Sql || [] : response.data.Sql || [];
  await compareAndUpdateUnidades(unidadesApi);
  await removeInexistentes(unidadesApi);
  return unidadesApi;
}

function getIndexedDBUnidades() {
  return idbService.getAll(storeName);
}

async function compareAndUpdateUnidades(unidades) {
  if (unidades && unidades.length) {
    for (const unidade of unidades) {
      await updateUnidade(unidade);
    }
  } else {
    // Limpa os registros do store unidades
    await idbService.clearStore(storeName);
  }
}

async function removeInexistentes(unidadesApi) {
  if (unidadesApi && unidadesApi.length) {
    const idsUnidadesApi = unidadesApi.map(unidadeApi => unidadeApi.id_unidade);
    const unidadesLocal = await idbService.getAll(storeName);
    const unidadesInexistentes = unidadesLocal.filter(unidadeLocal => !idsUnidadesApi.includes(unidadeLocal.id_unidade));
    if (unidadesInexistentes && unidadesInexistentes.length) {
      for (const unidade of unidadesInexistentes) {
        await idbService.deleteFromStore(storeName, unidade.id_unidade);
      }
    }
  } else {
    return;
  }
}

async function updateUnidade(unidade) {
  await idbService.updateItem(storeName, unidade);
}